export const CommonGlobals = {
    textErrorSearchAffiliate: 'Filtro (Búsqueda).',
}